import { getDayOfWeekValueFromDateTime } from 'utils/dateUtils';
import useCurrentOrganizationOvertimePeriod from '../useCurrentOrganizationOvertimePeriod/useCurrentOrganizationOvertimePeriod';
import { getEffectiveDate } from 'utils/organizationOvertimeUtils';

export default function useOrganizationOvertimeCurrentDayStart() {
  const currentOvertimePeriod = useCurrentOrganizationOvertimePeriod();
  return currentOvertimePeriod ? getDayOfWeekValueFromDateTime(getEffectiveDate(currentOvertimePeriod)) : null;
}
